import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IAudit } from './audit.state';

export const selectAuditFeature = createFeatureSelector<IAudit>('audit');

export const selectAuditMessage = createSelector(
  selectAuditFeature,
  (state: IAudit) => state.message,
);
export const selectToken = createSelector(
  selectAuditFeature,
  (state: IAudit) => state.token,
);

export const selectIsIframe = createSelector(
  selectAuditFeature,
  (state: IAudit) => state.isIframe,
);
